import { render } from "./Exchange.vue?vue&type=template&id=1ec6d833&scoped=true"
import script from "./Exchange.vue?vue&type=script&lang=js"
export * from "./Exchange.vue?vue&type=script&lang=js"

import "./Exchange.vue?vue&type=style&index=0&id=1ec6d833&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec6d833"]])

export default __exports__